import React from "react";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import MDButton from "components/MDButton";
import PageShell, { SectionCard } from "components/patch/PageShell";

export default function SalarySetup() {
  return (
    <PageShell title="Salary Structures & Pay Items" subtitle="Jump directly to salary structures, pay items, earnings and deductions.">
      <SectionCard title="Open Module">
        <Grid container spacing={2}>
          {[
            ["Salary Structures", "/setup/salary-structures"],
            ["Pay Items", "/setup/pay-items"],
            ["Earnings", "/setup/earnings"],
            ["Deductions", "/setup/deductions"],
            ["Mapped Salary Structure", "/setup/map-salary-structure"],
          ].map(([label, path]) => (
            <Grid item xs={12} md={4} key={path}>
              <MDButton component={Link} to={path} variant="gradient" color="success" fullWidth>{label}</MDButton>
            </Grid>
          ))}
        </Grid>
      </SectionCard>
    </PageShell>
  );
}
